module.exports = __webpack_public_path__ + "static/media/mark-5.jpeg";